module.exports = "js/webpack/2e59ba615169ea5c7506a8094f9e1301.png";